import React from 'react';

const HamburgerIcon = props => {
    return (
        <div className="hamburger-icon" onClick={props.clicked}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}

export default HamburgerIcon;